<template>
  <div>
    <HotelDisplayContainer />
  </div>
</template>

<script>
import HotelDisplayContainer from '@/modules/hoteldisplay'
export default {
  name: 'home',
  components: {
    HotelDisplayContainer,
  },
  breadcrumb() {
    return {
      label: this.$route.params.name,
      parent: 'search',
    }
  },
}
</script>
